import { PageHeader } from '@/components/shared/page-header';
import { CardSkeleton } from '@/components/shared/skeleton';

export function Loading() {
  return (
    <>
      <PageHeader title="Trip planner" description="Plan routes with stops and find charging stations along the way." />
      <CardSkeleton />
    </>
  );
}
